import { Chip, styled } from "@mui/material";

export const StyledChip = styled(Chip)(({ theme }) => ({
    justifyContent: "left",
    "& .icon": {
        color: "inherit",
        border: 0,
    },
    "&.NONE": {
        color: theme.palette.primary.main,
        border: 0,
    },
    "&.REPLACED": {
        color: theme.palette.primary.main,
        border: 0,
    },
    "&.ERROR": {
        color: theme.palette.error.light,
        border: 0,
    },
    "&.NOT_ACTIVE": {
        color: theme.palette.error.light,
        border: 0,
    },
}));
